import { Font } from "@moneyforward/mfx_biz_react_components";
import { SelectRowContainer, SelectRowItemCell } from "@/components/atoms";
import { PlanRowHeaderPart } from "@/components/molecules/PlanRowHeaderPart";
import { BankServices } from "@/generated/graphql_billing";

type Prop = {
  services: BankServices["services"];
};

export const SelectPlanRowHeader = ({ services }: Prop) => {
  return (
    <SelectRowContainer
      minWidth={960}
      minHeight={52}
      gridTemplateColumns={`2.28fr 1.3fr ${
        services && services.map((_) => "1.3fr").join(" ")
      } 0.01fr 1.95fr 0.01fr 0.55fr`}
    >
      <SelectRowItemCell rightBorderDisplay>
        <Font variant="s">プラン名</Font>
      </SelectRowItemCell>
      <SelectRowItemCell rightBorderDisplay>
        <Font variant="s">月額料金（税込）</Font>
      </SelectRowItemCell>
      <PlanRowHeaderPart services={services} />
    </SelectRowContainer>
  );
};
